import { useEffect, useRef } from 'react';
import { getHelpUrl } from '@/lib/urls';

export default function HelpPage() {
  const iframeRef = useRef<HTMLIFrameElement | null>(null);

  useEffect(() => {
    const frame = iframeRef.current;
    if (!frame) return;

    const bindLogo = () => {
      try {
        const doc = frame.contentDocument || frame.contentWindow?.document;
        if (!doc) return;

        const wire = (root: Document | HTMLElement) => {
          const img = root.querySelector('img[alt="Lumiplot"], img[src="/help/logo.png"]') as HTMLImageElement | null;
          if (img && !(img as any).__lumiBound) {
            (img as any).__lumiBound = true;
            img.style.cursor = 'pointer';
            img.addEventListener('click', (e) => {
              try { e.preventDefault(); } catch {}
              try { (window.top || window).location.assign('/'); } catch { window.location.assign('/'); }
            });
          }

          // Also bind the enclosing anchor if present so clicks near the logo still pop out of the iframe
          const anchor = img?.closest('a');
          if (anchor && !(anchor as any).__lumiBound) {
            (anchor as any).__lumiBound = true;
            anchor.addEventListener('click', (e) => {
              try { e.preventDefault(); } catch {}
              try { (window.top || window).location.assign('/'); } catch { window.location.assign('/'); }
            });
          }
        };

        // Initial attempt
        wire(doc);

        // Observe late renders
        const obs = new MutationObserver(() => wire(doc));
        try { obs.observe(doc.body || doc.documentElement, { childList: true, subtree: true }); } catch {}
        // Clean up on unload
        frame.addEventListener('load', () => { try { obs.disconnect(); } catch {} }, { once: true });
      } catch {}
    };

    // Bind immediately (if DOM already available) and again on load
    try { bindLogo(); } catch {}
    frame.addEventListener('load', bindLogo);
    return () => { try { frame.removeEventListener('load', bindLogo); } catch {} };
  }, []);

  // Render the docs static site inside an iframe without an extra app header
  // Docs are served from the external frontend site (www.lumiplot.ai/help)
  const helpUrl = getHelpUrl();
  
  return (
    <div className="fixed inset-0 bg-background">
      <iframe
        ref={iframeRef}
        title="Lumiplot Docs"
        src={helpUrl}
        className="absolute inset-0 w-full h-full border-0"
      />
    </div>
  );
}


